import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { PartnerEndpoint } from '../constants/partner-endpoint';
import { PartnerModel, PartnerRequestModel } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PartnerItemService {
  constructor(private http: WrapperHttpService) {}

  getPartnerDetails(partnerId: string): Observable<PartnerModel> {
    return this.http.withLoading().get<PartnerModel>(`${API_URL}${PartnerEndpoint.Base}/${partnerId}`);
  }

  approvePartner(partnerId: string): Observable<PartnerModel> {
    return this.http
      .withLoading()
      .post<PartnerModel>(`${API_URL}${PartnerEndpoint.Base}${PartnerEndpoint.Approve}/${partnerId}`, {});
  }

  createPartner(body: PartnerRequestModel): Observable<PartnerModel> {
    return this.http.withLoading().post<PartnerModel>(`${API_URL}${PartnerEndpoint.Base}`, body);
  }

  updatePartner(body: PartnerRequestModel): Observable<PartnerModel> {
    return this.http.withLoading().post<PartnerModel>(`${API_URL}${PartnerEndpoint.Base}`, body);
  }

  deletePartners(partnerIds: number[]): Observable<void> {
    return this.http.withLoading().delete<void>(`${API_URL}${PartnerEndpoint.Base}`, {
      body: partnerIds,
    });
  }

  getCarrierShortNames(): Observable<string[]> {
    return this.http.withLoading().get<string[]>(`${API_URL}${PartnerEndpoint.Base}${PartnerEndpoint.ShortNames}`);
  }
}
